import {AppState} from "./app.state";

export const getUser = (state: AppState) => state.app.user;
export const getSelectedReportId = (state: AppState) => state.app.selectedReportId;
export const getNetworkStatus = (state: AppState) => state.app.network;
export const isRehydrated = (state: AppState) => state.app.rehydrated;


